import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

class MiningChangePhasePopup extends React.Component {
  /**
   *  Component constructor.
   */
  constructor(props) {
    super(props)
  }

  removePopup() {
    const { removePopup, removeScreen, nextPhase, syncWithSettings, settings } = this.props

    nextPhase()
    removePopup('mining_change_phase_popup')
    removeScreen('mining_screen')
    settings.mineDisclaimer ? syncWithSettings(settings) : null
  }

  render() {
    const { setMineDisclaimer } = this.props

    return (
      <div className="popup--game">
        <div className="popup--box">
          <div className="popup--box__canvas">
            <div className="popup--heading">
              <FormattedMessage id={'popups.buildingPhase.title'} />
            </div>
            <div className="popup--text">
              <FormattedMessage id={'popups.buildingPhase.text'} />
            </div>
            <div className="checkbox">
              <input
                onChange={() => setMineDisclaimer()}
                type="checkbox"
                id="option1"
                name="option"
              />
              <label htmlFor="option1">
                <FormattedMessage
                  id="popups.do_not_show_again"
                  defaultMessage="Do not show again"
                />
              </label>
            </div>
            <div className="popup--buttons">
              <div onClick={() => this.removePopup()} className="btn--shape shape--blue">
                <div className="btn--shape__canvas">
                  <FormattedMessage id="popups.accept" defaultMessage="Accept" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

MiningChangePhasePopup.propTypes = {
  nextPhase: PropTypes.func,
  removePopup: PropTypes.func,
  removeScreen: PropTypes.func,
  setMineDisclaimer: PropTypes.func,
  syncWithSettings: PropTypes.func,
  settings: PropTypes.object,
}

export default MiningChangePhasePopup
